let code = 'toponymy';
let codeAPI = 'toponymy';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};